import Swiper from 'swiper';
import { Metrika } from '../components/metrika';
import { Analytics } from '../components/analytics';

export function stepsSlider() {
    const metrika = new Metrika;
    const analytics = new Analytics;

    let sliderSteps = new Swiper('.steps-slider', {
        containerModifierClass: 'steps-slider',
        wrapperClass: 'steps-slider__wrapper',
        slideClass: 'steps-slide',
        slideActiveClass: 'is-active',
        width: 290,
        breakpoints: {
            780: {
                width: 560,
            }
        }
    });

    let bullets = document.querySelectorAll('[am-item="steps"]'),
        btn = document.querySelector('[am-btn="steps"]'),
        prev = document.querySelector('[am-prev="steps"]'),
        next = document.querySelector('[am-next="steps"]');

    function pagination(index) {
        bullets.forEach( function(item) {
            item.classList.remove('is-active');
        });

        for (let i = 0; i <= index; i++) {
            bullets[i].classList.add('is-active');

            if (i == 5) {
                btn.classList.add('is-active');
                next.classList.add('is-hidden');

                metrika.reachGoal('FORM_STEPS_END', btn);
                analytics.event('FORM_STEPS_END', btn);
            } else {
                btn.classList.remove('is-active');
                next.classList.remove('is-hidden');
            }
        }
    };

    sliderSteps.on('slideChange', function() {
        let index = this.realIndex;
        pagination(index);
    });

    bullets.forEach( function(item) {
        item.addEventListener('click', function() {
            let index = item.textContent - 1;
            sliderSteps.slideTo(index);
            pagination(index);
        });
    });

    if (prev) {

        prev.addEventListener('click', function() {
            sliderSteps.slidePrev()
        });

        next.addEventListener('click', function() {
            sliderSteps.slideNext()
        });

    }
}